import { ZaiChatSideChat } from '@winnin/zai-chat'

import type { IZaiSideChatView } from './zai-side-chat.types'

export const ZaiSideChatView = ({ isOpen, onOpenChange }: IZaiSideChatView) => (
  <div className="zai-side-chat" data-open={isOpen}>
    <ZaiChatSideChat isOpen={isOpen} onOpenChange={onOpenChange} />
  </div>
)
